import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { DeploymentActivity } from '../../../common/services/deployment-activity-context.service';

@Component({
    selector: 'adm4-tabs-deployment-activity',
    template: `
      @for (deployment of localJobActivities; track deployment) {
        <p class="local-activity">
          <strong>You</strong> have started a background deployment
          of <strong>{{deployment.projectKey | cropTenantFromKey}}</strong>
          to <strong>{{deployment.inventoryKey | cropTenantFromKey}}</strong>.
        </p>
      }
      @if (showSeparator) {
        <hr/>
      }
      @for (deployment of historyActivities; track deployment) {
        <p class="history-activity">
          User <strong>{{deployment.userKey}}</strong> has started a deployment of
          @if (!deployment.isProjectRedacted) {
            <strong>{{deployment.projectKey  | cropTenantFromKey}}</strong>
          } @else {
            an undisclosed project
          }
          to
          @if (!deployment.isInventoryRedacted) {
            <strong>{{deployment.inventoryKey | cropTenantFromKey}}</strong>
          } @else {
            an undisclosed inventory
          }
          .
        </p>
      }
      `,
    standalone: false
})
export class TabsDeploymentActivityComponent implements OnChanges {

  @Input() activities: DeploymentActivity[] | undefined;

  public localJobActivities: DeploymentActivity[] = [];
  public historyActivities: DeploymentActivity[] = [];
  public showSeparator: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.activities) {
      this.localJobActivities = (this.activities??[]).filter((activity: DeploymentActivity): boolean => activity.localJob);
      this.historyActivities = (this.activities??[]).filter((activity: DeploymentActivity): boolean => !activity.localJob);
      this.showSeparator = this.localJobActivities.length > 0 && this.historyActivities.length > 0;
    }
  }

}
